import OrbitControls from 'orbit-controls-es6';
import * as THREE from 'three';
const TWEEN = require('@tweenjs/tween.js');

export default {
  data() {
    return {
      camera: null,
      controls: null
    }
  },
  computed: {
    modelViews() {
      return this.$store.state.utils.modelViews;
    },
  },
  methods: {
    setupCamera() {
      const { camera_settings } = this.pdm.default_display.scene_defaults;
      this.camera = new THREE.PerspectiveCamera(
        camera_settings.fov,
        window.innerWidth / window.innerHeight,
        camera_settings.near,
        camera_settings.far
      );

      this.camera.position.set(camera_settings.position[0], camera_settings.position[1], camera_settings.position[2]);
      this.camera.setLens(camera_settings.setLens);
      this.camera.zoom = (window.innerHeight / 1000).toFixed(1);
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.$model3D.camera = this.camera;
      this.setupOrbitControls();
      if (this.$store.getters["utils/getUrlParameterByName"]("changeView") === "true") this.addChangeViewToGlobalEscope();
    },
    setupOrbitControls() {
      const controls = this.pdm.default_display.scene_defaults.controls.desktop;
      this.controls = new OrbitControls(this.camera, this.$model3D.renderer.domElement);
      this.controls.enableDamping = controls.enableDamping;
      this.controls.dampingFactor = 0.25;
      this.controls.enableZoom = controls.enableZoom;
      this.controls.maxPolarAngle = controls.maxPolarAngle > 0 ? controls.maxPolarAngle : Math.PI / 2;
      this.controls.minPolarAngle = controls.minPolarAngle > 0 ? controls.minPolarAngle : 0;
      this.controls.zoomSpeed = controls.zoomSpeed;
      this.controls.enableRotate = true;
      this.controls.rotateSpeed = controls.rotateSpeed;
      this.controls.enableKeys = controls.enableKeys;
      this.controls.enablePan = controls.enablePan;
      this.controls.autoRotateSpeed = controls.autoRotateSpeed;
      this.controls.autoRotate = false; // Set false so as not to conflict w/ intro animation
      this.controls.update();
    },
    updateCameraPosition() {
      const modelPosition = this.$model3D.modelObj.position;
      this.controls.target.set(modelPosition.x, modelPosition.y, modelPosition.z);
    },
    setupLights() {
      const { lighting } = this.pdm.default_display.scene_defaults;
      for (let [index, item] of lighting.entries()) {
        let light = new THREE[item.type]();
        if (light.groundColor) light.groundColor = new THREE.Color(item.groundColor) || null;
        if (light.skyColor) light.skyColor = new THREE.Color(item.skyColor) || null;
        if (item.name) light.name = item.name || `${item.type}-${index}`;
        if (light.color && light.type !== 'HemisphereLight') light.color = new THREE.Color(item.color) || new THREE.Color("#ffffff");
        if (light.position && light.type !== 'AmbientLight') light.position.set(item.position[0], item.position[1], item.position[2]);
        if (light.angle) light.angle = item.angle || Math.PI / 3;
        if (typeof light.distance !== "undefined") light.distance = item.distance || 0.0;
        if (light.intensity) light.intensity = item.intensity || null;
        if (light.decay) light.decay = item.decay || 1;
        if (light.penumbra) light.penumbra = item.penumbra || 0.0;
        if (item.castShadow) light.castShadow = item.castShadow || true;
        if (item.receiveShadow) light.receiveShadow = item.receiveShadow || true;
        if (light.shadow) light.shadow.mapSize.width = item.shadowMapSizeWidth || 512;
        if (light.shadow) light.shadow.mapSize.height = item.shadowMapSizeHeight || 512;
        this.$model3D.rootObj.add(light);

        // Uncomment to show spotlight helpers when lighting a scene
        // if (light.type === 'SpotLight') {
        //   const spotLightHelper = new THREE.SpotLightHelper(light);
        //   this.$model3D.rootObj.add(spotLightHelper);
        // }
      };
    },
    changeView(view) {
      if (!view) {
        console.error("View name is required");
        return;
      }
      if (!this.modelViews[view]) {
        console.error(`Couldn't find view name: ${view}`);
        return;
      }
      const position = this.modelViews[view];
      if (position.length !== 3) {
        console.error("Position array must have 3 elements");
        return;
      }
      this.camera.position.set(position[0], position[1], position[2]);
    },
    updateModelViews(modelViews) {
      this.$store.commit('utils/SET_MODEL_VIEWS', modelViews);
    },
    addChangeViewToGlobalEscope() {
      // removes if already defined
      if (window.hasOwnProperty('changeView')) delete window.changeView;
      if (window.hasOwnProperty('updateModelViews')) delete window.updateModelViews;
      // adds a global function to window object to change model view
      window.changeView = this.changeView;
      window.updateModelViews = this.updateModelViews;

    },
    /**
     * @function rotateModelComponent
     * Rotate the model using Tween library.
     */
    rotateModelComponent(data = null, component = "") {
      if (!this.camera && !this.camera.position)
        return;

      const tween = new TWEEN.default.Tween(this.camera.position).to(data, 2500).onComplete(() => {
        this.$eventBus.$emit("component-selected", component);
      }).easing(TWEEN.default.Easing.Back.InOut);
      tween.start();
    }
  },
};
